<template>
  <div v-if="trackingData" :class="{ hidden: !isDev }">
    <div class="hidden">Tracking Active</div>
  </div>
</template>

<script setup lang="ts">
const { trackingData, getTrackingData } = useCrossDomainTracking();
const config = useRuntimeConfig();
const isDev = computed(() => config.public.dev);

// Log tracking data when it changes
watch(trackingData, (newValue) => {
  if (newValue) {
    console.log("Tracking data updated:", {
      customerId: newValue.shopify.customerId,
      sessionId: newValue.clarity.sessionId,
      timestamp: new Date(newValue.timestamp).toISOString(),
    });

    // Ensure Clarity is initialized with the session data
    if (process.client && window.clarity && newValue.clarity.sessionId) {
      window.clarity("set", "sessionId", newValue.clarity.sessionId);
      if (newValue.clarity.userId) {
        window.clarity("set", "userId", newValue.clarity.userId);
      }
    }
  }
});

// Initialize tracking data
onMounted(() => {
  getTrackingData();

  // Ensure Clarity is initialized
  if (process.client && window.clarity) {
    window.clarity("consent");
  }
});

// Clean up on unmount
onUnmounted(() => {
  // Any cleanup if needed
});
</script>

<style scoped>
.hidden {
  display: none;
}
</style>
